"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LogLevel_1 = require("./LogLevel");
/**
 * [[NoOpLogger]] does not log any message.
 */


var NoOpLogger = /*#__PURE__*/function () {
  function NoOpLogger() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LogLevel_1.default.OFF;

    _classCallCheck(this, NoOpLogger);

    this.level = level;
  }

  _createClass(NoOpLogger, [{
    key: "info",
    value: function info(_msg) {}
  }, {
    key: "warn",
    value: function warn(_msg) {}
  }, {
    key: "error",
    value: function error(_msg) {}
  }, {
    key: "debug",
    value: function debug(debugFunction) {
      if (LogLevel_1.default.DEBUG < this.level) {
        return;
      }

      if (typeof debugFunction !== 'string') {
        debugFunction();
      }
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(level) {
      this.level = level;
    }
  }, {
    key: "getLogLevel",
    value: function getLogLevel() {
      return this.level;
    }
  }]);

  return NoOpLogger;
}();

exports.default = NoOpLogger;